import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

/* Layout */
// import Layout from '@/layout'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
    routes: [{
            // name: 'index',
            path: '/',
            component: HomeView,
            meta: {
                title: "首页",
                showFather: true,
            },
            // children:[

            // ],
            children: [

                {
                    name: 'allcontent',
                    path: '/allcontent',
                    component: () => import('@/views/allcontent.vue'),
                    meta: {
                        title: "首页",
                        showFather: true,
                    },
                },
                // 个人中心
                {
                    name: '个人中心',
                    path: '/personal/index',
                    component: () => import('@/views/personal/index.vue'),
                    meta: {
                        title: "个人中心",
                        showFather: true,
                    },
                    children: [
                        // 个人信息-有解锁的专家unlockedExperts
                        {
                            name: '我的专家',
                            path: '/personal/unlockedExperts',
                            component: () => import('@/views/personal/unlockedExperts.vue'),
                            meta: {
                                title: "我的专家",
                                showFather: false,
                            },

                        },
                        // 开通会员
                        {
                            name: '开通会员',
                            path: '/personal/member/activateMembership',
                            component: () => import(
                                '@/views/personal/member/activateMembership.vue'),
                            meta: {
                                title: "开通会员",
                                showFather: true,
                            },
                            children: [{
                                name: '会员详情',
                                path: '/personal/member/details',
                                component: () => import(
                                    '@/views/personal/member/details.vue'),
                                meta: {
                                    title: "会员详情",
                                    showFather: true,
                                },
                                children: [
                                    // 微信支付
                                    {
                                        name: '/member/payment',
                                        path: '/personal/member/payment',
                                        component: () => import(
                                            '@/views/personal/member/payment.vue'),
                                        meta: {
                                            title: "微信支付",
                                            showFather: false,
                                        },
                                    },
                                    {
                                        // 支付失败
                                        name: '/member/paymentFail',
                                        path: '/personal/member/paymentFail',
                                        component: () => import(
                                            '@/views/personal/member/paymentFail.vue'
                                            ),
                                        meta: {
                                            title: "支付失败",
                                            showFather: false,
                                        },

                                    },
                                    // 支付成功
                                    {
                                        name: '/member/paymentSuccess',
                                        path: '/personal/member/paymentSuccess',
                                        component: () => import(
                                            '@/views/personal/member/paymentSuccess.vue'),
                                        meta: {
                                            title: "支付成功",
                                            showFather: false,
                                        },
                                    }


                                ]
                            }, ]
                        },

                        // children:[
                        {
                            name: '我的会员',
                            path: '/personal/member/index',
                            component: () => import('@/views/personal/member/index.vue'),
                            meta: {
                                title: "我的会员",
                                showFather: true,
                            },
                            children: [{
                                name: '会员记录',
                                path: '/personal/member/record',
                                component: () => import(
                                    '@/views/personal/member/record.vue'),
                                meta: {
                                    title: "会员记录",
                                    showFather: false,
                                },
                            }, ]
                        },

                        // ]

                        {
                            name: '个人信息',
                            path: '/personal/infomation',
                            component: () => import('@/views/personal/infomation.vue'),
                            meta: {
                                title: "个人信息",
                                showFather: false,
                            },

                        },
                        {
                            name: '直播预约',
                            path: '/personal/service/reservation',
                            component: () => import('@/views/personal/service/reservation.vue'),
                            meta: {
                                title: "直播预约",
                                showFather: false,
                            },
                        },
                        {
                            name: '收藏专家',
                            path: '/personal/collect/index',
                            component: () => import('@/views/personal/collect/index.vue'),
                            meta: {
                                title: "收藏专家",
                                showFather: false,
                            },
                        },

                        {
                            name: '发票申请',
                            path: '/personal/service/invoice/index',
                            component: () => import('@/views/personal/service/invoice/index.vue'),
                            meta: {
                                title: "发票申请",
                                showFather: true,
                            },
                            children: [{
                                name: '我的发票',
                                path: '/personal/service/invoice/myInvoice',
                                component: () => import(
                                    '@/views/personal/service/invoice/myInvoice.vue'),
                                meta: {
                                    title: "我的发票",
                                    showFather: true,
                                },
                                children: [{
                                        name: '/invoice/invoiceDetail',
                                        path: '/personal/service/invoice/invoiceDetail',
                                        component: () => import(
                                            '@/views/personal/service/invoice/invoiceDetail.vue'
                                        ),
                                        meta: {
                                            title: "发票详情",
                                            showFather: true,
                                        },
                                        children: [{
                                            name: '/invoice/relatedOrders',
                                            path: '/personal/service/invoice/relatedOrders',
                                            component: () => import(
                                                '@/views/personal/service/invoice/relatedOrders.vue'
                                            ),
                                            meta: {
                                                title: "关联订单",
                                                showFather: false,
                                            }
                                        }]
                                    },

                                ]
                            }, {
                                name: '/invoice/inInformation',
                                path: '/personal/service/invoice/inInformation',
                                component: () => import(
                                    '@/views/personal/service/invoice/inInformation.vue'
                                ),
                                meta: {
                                    title: "填写信息",
                                    showFather: true,
                                    keepAlive: true
                                },
                                children: [{
                                    name: '/invoice/submitApplication',
                                    path: '/personal/service/invoice/submitApplication',
                                    component: () => import(
                                        '@/views/personal/service/invoice/submitApplication.vue'
                                    ),
                                    meta: {
                                        title: "提交申请",
                                        showFather: false,
                                    }
                                }]
                            }]
                        },
                        {
                            name: '证书查询',
                            path: '/personal/service/certificate/index',
                            component: () => import(
                                '@/views/personal/service/certificate/index.vue'),
                            meta: {
                                title: "证书查询",
                                showFather: true,
                            },
                            children: [{
                                name: '/certificate/query',
                                path: '/personal/service/certificate/query',
                                component: () => import(
                                    '@/views/personal/service/certificate/query.vue'),
                                meta: {
                                    title: "查询结果",
                                    showFather: false,
                                }
                            }]
                        },
                        {
                            name: '联系客服',
                            path: '/personal/service/customer',
                            component: () => import('@/views/personal/service/customer.vue'),
                            meta: {
                                title: "联系客服",
                                showFather: true,
                            },
                        },
                        {
                            name: '用户协议',
                            path: '/personal/service/userAgreement',
                            component: () => import('@/views/personal/service/userAgreement.vue'),
                            meta: {
                                title: "用户协议",
                                showFather: true,
                            },
                        },
                        {
                            name: '隐私协议',
                            path: '/personal/service/privacyAgreement',
                            component: () => import(
                                '@/views/personal/service/privacyAgreement.vue'),
                            meta: {
                                title: "隐私协议",
                                showFather: true,
                            },
                        },
                        {
                            name: '我的活动',
                            path: '/personal/activity/index',
                            component: () => import('@/views/personal/activity/index.vue'),
                            meta: {
                                title: "我的活动",
                                showFather: true,
                            },
                            children: [
                                // 报名信息
                                {
                                    name: '/activity/information',
                                    path: '/personal/activity/information',
                                    component: () => import(
                                        '@/views/personal/activity/information.vue'),
                                    meta: {
                                        title: "报名信息",
                                        showFather: false,
                                    },
                                },
                                // 搜索活动
                                {
                                    name: '/activity/searchActivity',
                                    path: '/personal/activity/searchActivity',
                                    component: () => import(
                                        '@/views/personal/activity/searchActivity.vue'),
                                    meta: {
                                        title: "搜索活动",
                                        showFather: false,
                                    },
                                },
                            ]
                        },


                    ]
                },
				{
				    name: 'bannerDetails',
				    path: '/bannerDetails',
				    component: () => import('@/views/bannerDetails.vue'),
				    meta: {
				        title: "轮播图详情",
				        showFather: true,
				    },
				},
                {
                    name: 'wisdom',
                    path: '/expert/wisdom',
                    component: () => import('@/views/expert/wisdom.vue'),
                    meta: {
                        title: "专家智库",
                        showFather: true,
						keepAlive: true
                    },
                    children: [
                        // 专家详情
                        {
                            name: 'expertDetail',
                            path: '/expert/expertDetail',
                            component: () => import('@/views/expert/expertDetail.vue'),
                            meta: {
                                title: "专家详情",
                                showFather: false,
                            },
                        }
                    ]
                }, {
                    name: 'school',
                    path: '/famous/school',
                    component: () => import('@/views/famous/school.vue'),
                    meta: {
                        title: "名校风采",
                        showFather: true,
                    },
                    children: [
                        // 学校详情
                        {
                            name: 'schoolDetail',
                            path: '/famous/schoolDetail',
                            component: () => import('@/views/famous/schoolDetail.vue'),
                            meta: {
                                title: "学校详情",
                                showFather: false,
                            },
                        }
                    ]
                }, {
                    name: 'zone',
                    path: '/training/zone',
                    component: () => import('@/views/training/zone.vue'),
                    meta: {
                        title: "培训专区",
                        showFather: true,
                    },
                    children: [
                        // 培训详情
                        {
                            name: 'detail',
                            path: '/training/detail',
                            component: () => import('@/views/training/detail.vue'),
                            meta: {
                                title: "培训详情",
                                showFather: false,
                            },
                        }
                    ]
                }, {
                    name: 'activity',
                    path: '/activity/index',
                    component: () => import('@/views/activity/index.vue'),
                    meta: {
                        title: "近期活动",
                        showFather: true,
                    },
                    children: [
                        // 活动详情
                        {
                            name: 'activityDetail',
                            path: '/activity/activityDetail',
                            component: () => import('@/views/activity/activityDetail.vue'),
                            meta: {
                                title: "活动详情",
                                showFather: true,
                            },
                            children: [
                                // 报名信息
                                {
                                    name: 'information',
                                    path: '/activity/information',
                                    component: () => import('@/views/activity/information.vue'),
                                    meta: {
                                        title: "报名信息",
                                        showFather: true,
                                    },
                                    children: [
                                        // 微信支付
                                        {
                                            name: '/activity/payment',
                                            path: '/activity/payment',
                                            component: () => import(
                                                '@/views/activity/payment.vue'),
                                            meta: {
                                                title: "微信支付",
                                                showFather: false,
                                            },
                                        },
                                        // 支付失败
                                        {
                                            name: '/activity/paymentFail',
                                            path: '/activity/paymentFail',
                                            component: () => import(
                                                '@/views/activity/paymentFail.vue'),
                                            meta: {
                                                title: "支付失败",
                                                showFather: false,
                                            },
                                        },
                                        // 支付成功
                                        {
                                            name: '/activity/paymentSuccess',
                                            path: '/activity/paymentSuccess',
                                            component: () => import(
                                                '@/views/activity/paymentSuccess.vue'),
                                            meta: {
                                                title: "支付成功",
                                                showFather: false,
                                            },
                                        }
                                    ]
                                },

                            ]
                        }
                    ]
                }, {
                    name: 'broadcast',
                    path: '/broadcast/index',
                    component: () => import('@/views/broadcast/index.vue'),
                    meta: {
                        title: "精彩直播",
                    },
                }, {
                    name: 'collect',
                    path: '/collect/index',
                    component: () => import('@/views/collect/index.vue'),
                    meta: {
                        title: "我的收藏",
                    },
                },


            ],

            // hidden: true
        },
        // {
        //     name: 'personal',
        //     path: '/personal/index',
        //     component:()=>import('@/views/personal/index.vue'),
        //     meta: {
        //         title: "个人中心",
        //     },
        //     children:[
        //         // 个人首页
        //           {
        //             name: 'home',
        //             path: '/personal/home',
        //             component:()=>import('@/views/personal/home.vue'),
        //             meta: {
        //                 title: "个人首页",
        //             },
        //           },
        //           // 个人信息
        //           {
        //             name: 'infomation',
        //             path: '/personal/infomation',
        //             component:()=>import('@/views/personal/infomation.vue'),
        //             meta: {
        //                 title: "个人中心",
        //             },
        //           },
        //       ],
        // },


    ],
    mode: 'history'
})


router.beforeEach((to, from, next) => {

    // 路由跳转后，让页面回到顶部
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    window.pageYOffset = 0;
	window.previousRoute = from
    // 调用 next()，一定要调用 next 方法，否则钩子就不会被销毁!!
    next();

});

export default router
